import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Daily.css'; // Reutilizamos estilos
import slide1 from '../assets/notasentrega.avif';
import slide2 from '../assets/panelalmacen.avif';
import slide3 from '../assets/inventarioalma.avif';
import slide4 from '../assets/devoluciones.avif';
import slide5 from '../assets/consolidacion.avif';
import { PackageX, ListChecks, PackageSearch, Truck, Settings2 } from 'lucide-react';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

const Daily = () => {
  const navigate = useNavigate();

  return (
    <motion.div 
      className="dashboard-container"
      initial={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      animate={isMobile ? { opacity: 1, y: 0 } : { opacity: 1, y: 0 }}
      exit={isMobile ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={isMobile ? { duration: 0 } : { duration: 0.5 }}
    >
      <div className="title-section">
        <h1 className="dailymenu">Módulo Almacen</h1>
        <div className="title-underline-daily"></div>
        <h1 className="subtitle-daily">Almacen</h1>
      </div>

      <div className="daily-menu-grid">

        {/* Card 4: Panel de Almacén */}
          <div className="daily-card" onClick={() => navigate('/panelalmacen')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide2})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Settings2 size={28} color="white" />
              </div>
              <h3>Panel de Almacén</h3>
              <p>Flota de camiones, tarifario y rutas de despacho.</p>
            </div>
          </div>


          {/* Card 1: Notas de Entrega */}
          <div className="daily-card" onClick={() => navigate('/almacennotasentrega')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide1})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <ListChecks size={28} color="white" />
              </div>
              <h3>Notas de Entrega</h3>
              <p>Detalle de Notas de Entrega.</p>
            </div>
          </div>

          

          {/* Card 3: Consolidación de Despacho */}
          <div className="daily-card" onClick={() => navigate('/consolidaciondespacho')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide5})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <Truck size={28} color="white" />
              </div>
              <h3>Consolidación de Despacho</h3>
              <p>Optimización y certificación de rutas y cargas.</p>
            </div>
          </div>

          {/* Card 2: Devoluciones */}
          <div className="daily-card" onClick={() => navigate('/notascalmacen')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide4})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <PackageX size={28} color="white" />
              </div>
              <h3>Devoluciones</h3>
              <p>Notas de Crédito - Devoluciones.</p>
            </div>
          </div>

          {/* Card 5: Inventario */}
          <div className="daily-card" onClick={() => navigate('/inventarioalmacen')}>
            <div className="daily-card-bg-image" style={{ backgroundImage: `url(${slide3})` }}></div>
            <div className="daily-card-overlay"></div>
            <div className="daily-card-content">
              <div className="daily-card-icon-wrapper">
                <PackageSearch size={28} color="white" />
              </div>
              <h3>Inventario</h3>
              <p>Estado actual del inventario.</p>
            </div>
          </div>
      </div>
    </motion.div>
  );
};

export default Daily;